export const IMAGERY_VIEW = {
  Select: '',
  barcode: 'Barcode',
  reference: 'Reference',
  description: 'Description',
  masterSuiteName: 'Mastersuite (Variant)',
  states: 'Status',
  Actions: '',
} as const;

export const POST_VIEW = {
  Select: '',
  barcode: 'Barcode',
  reference: 'Reference',
  description: 'Description',
  Actions: '',
} as const;

export const CLIENT_VIEW = {
  Select: '',
  barcode: 'Barcode',
  reference: 'Reference',
  description: 'Description',
  Actions: '',
} as const;

export type ViewConfig = typeof IMAGERY_VIEW | typeof POST_VIEW | typeof CLIENT_VIEW;
